import { render, staticRenderFns } from "./CategoryLayer.vue?vue&type=template&id=7633d071&scoped=true&name=category-layer&"
import script from "./CategoryLayer.vue?vue&type=script&lang=js&"
export * from "./CategoryLayer.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLayer.vue?vue&type=style&index=0&id=7633d071&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7633d071",
  null
  
)

/* custom blocks */
import block0 from "./CategoryLayer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports